import protoRoot from "../proto-root";
import BatteryStatus from "../private/BatteryStatus";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";
import CameraInfo from "../private/CameraInfo";
import DataBuildInformation from "../private/DataBuildInformation";
import SupportedFeatures from "../private/SupportedFeatures";
import CameraAlarmStatus from "../private/CameraAlarmStatus";
import CameraRecordingStatus from "../private/CameraRecordingStatus";

const name = "startMonitoringRPCResponse";

type Payload = Omit<StartMonitoringResponse, "configuration" | "webRTCCreateAnswer"> & {
  configuration: {
    availableCameras: StartMonitoringResponse["configuration"]["availableCameras"];
  };
  webRTCCreateAnswer?: { sdp: string };
};

function create(payload: Payload) {
  const StartMonitoringRPCResponse = protoRoot.lookupType("comm.StartMonitoringRPCResponse");

  const batteryStatus = BatteryStatus.create(payload.batteryStatus);
  const cameraState = CameraAndFlashlightState.create({
    cameraId: payload.cameraState.cameraId || ""
  });
  const configuration = {
    availableCameras: payload.configuration.availableCameras.map((camera) => CameraInfo.create(camera)),
    versionInfo: DataBuildInformation.create(),
    supportedFeatures: SupportedFeatures.create()
  };
  const responsePayload: Record<string, unknown> = {
    batteryStatus,
    cameraState,
    configuration,
    alarmStatus: payload.alarmStatus ? CameraAlarmStatus.create(payload.alarmStatus) : undefined,
    videoRecordingStatus: payload.videoRecordingStatus
      ? CameraRecordingStatus.create(payload.videoRecordingStatus)
      : undefined
  };

  if (payload.webRTCCreateAnswer) {
    const WebRTCCreateAnswerMessage = protoRoot.lookupType("comm.WebRTCCreateAnswerMessage");
    responsePayload.webRTCCreateAnswer = WebRTCCreateAnswerMessage.create({ sdp: payload.webRTCCreateAnswer.sdp });
  }

  return {
    payload: StartMonitoringRPCResponse.create(responsePayload),
    name
  };
}

const startMonitoringRPCResponse = {
  create,
  name
};

export default startMonitoringRPCResponse;
